import React, { Component } from 'react';
import Loader from 'react-loader-spinner'
import 'semantic-ui-css/semantic.min.css'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import {Host} from '../../config/config'
import styled from 'styled-components';


const Newstitle = styled.div`
  font-size: 1.1em;
  font-weight: bold;
  color:#130c66;
  padding-left: 8px;
  padding-right: 8px;
  text-align: left;
  margin: 2px;
  display:flex;
  flex-direction: row;margin-top:12px;
  ${props=>(props.nopointer ? null: 'cursor: pointer;')}

  a:hover {
      text-decoration: underline;
    }
`


const NewsText = styled.div `
padding-left: 20px;
color:#0e1b53;
background: #fafbfc;

`

const NewsItem = styled.div `
border-bottom:solid 1px #adacb1;
${props=>(props.fullmode? 'padding:12px;' : null )}
${props=>(props.fullmode? 'margin-top:12px;margin-bottom:22px;' : null )}
${props=>(props.fullmode? 'font-size:1.2em;' : null )}
// ${props=>(props.fullmode? 'border:solid 1px blue;' : null )}
${props=>(props.fullmode? 'box-shadow: 0 0 10px rgba(0,0,0,0.5);' : null )}
${props=>(props.fullmode? 'color:blue;' : null )}
${props=>(props.fullmode? 'background:white;' : null )}
`

export default class News extends Component {

  constructor(props){
      super(props)
      this.fetcher=this.fetcher.bind(this)
      this.showAllMessage=this.showAllMessage.bind(this)

      this.state={

        fetcheddata:null,
        pagedata:null,
        isFetching:false,

        newsTextDraw:-1,
        showAllMessage:false
      }
  }




fetcher(id){
  this.setState({isFetching:true})
  fetch('http://'+Host+'/api/ocnitdate',
    {
  method: 'POST',
  headers: new Headers({
           'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
           'Access-Control-Allow-Origin': '*',
  }),
  body: "id="+id+"&section=news"
    }    )
    .then((response)=>response.json())
      .then((data)=>{
          // this.setState ({htm:data[0].htm})
          this.setState ({

            // htm:ReactHtmlParser(data[0].htm),
            fetcheddata:data,
            isFetching:false,

            },
           ()=>console.log('fetcheddata'+JSON.stringify(this.state.pagedata))
            )
          },


          )

}
showAllMessage(){
  this.fetcher(1)
}

componentDidMount() {

let id=0
  if(this.state.showAllMessage){
    id=1;
  }
this.fetcher(id)



}


render(){

  const { isFetching, showAllMessage, fetcheddata, newsTextDraw} = this.state

  return (

      <div style={{'height':'74vh', 'overflow-y':'scroll', 'text-align':'left'}}>

      <div className="leftbig">Новости

        </div>
              {fetcheddata ?
                <div>
                  {fetcheddata.map((data,key)=>
                      <NewsItem fullmode={newsTextDraw == key ? true:false}>



                        {newsTextDraw == key ?
                          <div>
                                <Newstitle nopointer={true}>
                                      {ReactHtmlParser(data.title)} &nbsp;&nbsp;&nbsp;<p style={{'font-style': 'italic', 'font-size':'0.8em'}}>({data.date_arch})</p>
                                </Newstitle>
                                <NewsText>
                                      {ReactHtmlParser(data.text)}
                                </NewsText>
                          </div>
                                :
                                <Newstitle>
                                      <a href={null} onClick={()=>this.setState({newsTextDraw:key})}>{ReactHtmlParser(data.title)}</a> &nbsp;&nbsp;&nbsp;<p style={{'font-style': 'italic', 'font-size':'0.8em'}}>({data.date_arch})</p>
                                </Newstitle>

                        }

                      </NewsItem>



                  )}

                </div>

        :
        null
    }
    {isFetching ?
          <Loader
           type="ThreeDots"
           color="#00BFFF"
           height="100"
           width="100"
        />
      :
      null
    }
      <div style={{'margin':'22px'}}>
          {showAllMessage ? null : <a href={null} style={{'cursor':'pointer'}} onClick={this.showAllMessage}>Показать все</a>}
      </div>


      </div>
  )
}
}

// export default Problem
